import { queryOptions, useQuery } from "@tanstack/react-query"

import type { QueryConfig } from "@/lib/react-query"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

type GetUploadProgressData = {
  videoId: string
}

type GetUploadProgressResponse = {
  progress: string
  state: string
  video_id: string
}

type UseGetUploadProgressProps = {
  videoId: string
  queryConfig?: QueryConfig<typeof getUploadProgressQueryOptions>
}

function getUploadProgress(data: GetUploadProgressData): Promise<GetUploadProgressResponse> {
  return api.get(`/video-insight/index-progress?video_id=${data.videoId}`)
}

export function getUploadProgressQueryOptions(data: GetUploadProgressData) {
  return queryOptions({
    queryKey: queryKeys.uploadProgress,
    queryFn: () => getUploadProgress(data),
  })
}

export function useGetUploadProgress({ videoId, queryConfig }: UseGetUploadProgressProps) {
  const getUploadProgressQuery = useQuery({
    ...getUploadProgressQueryOptions({ videoId }),
    ...queryConfig,
  })

  return { getUploadProgressQuery }
}
